import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ContentExpansion from "../../../../../components/ContentExpansion";
import { SpacerContainer } from "../../../../../components/styledComponents/SpacerContainer";
import { berechneKnickenOfner } from "../../../../../services/Inner/berechneKnickenOfner.service";
import { useGetTraggliedDatenQuery } from "../../../../../services/API/titanApi";
import { selectBemessungslast } from "../../../../../store/slices/bemessungslastSlice";
import { selectBohrkronendurchmesser } from "../../../../../store/slices/bohrkronendurchmesserSlice";
import {
  selectFrontendZustand,
  setKnickenNachOfnerWimmerDetails,
} from "../../../../../store/slices/frontendZustandSlice";
import {
  selectBiegesteifigkeit,
  selectDickeWeicheBodenschicht,
  selectKnickkoeffizient,
  selectKoeffizientNachGudehus,
  selectKoeffizientNachWenz,
  selectStaerkeDesZylinders,
  selectTeilsicherheitsbeiwertFuerGeotechnischenKenngroessen,
  selectTeilsicherheitsbeiwert,
  selectTeilsicherheitsbeiwertZement,
  selectUndraenierteScherfestigkeit,
  selectVerpresskoerperdurchmesser,
} from "../../../../../store/slices/innereSlice";
import { selectTragglied } from "../../../../../store/slices/traggliedSlice";
import Nachweis from "./Nachweis/Nachweis";
import ParameterBaugrund from "./ParameterBaugrund/ParameterBaugrund";
import ParameterTragglied from "./ParameterTragglied/ParameterTragglied";
import ParameterVerpresskoerper from "./ParameterVerpresskoerper/ParameterVerpresskoerper";
import TragfaehigkeitenMikropfahl from "./TragfaehigkeitenMikropfahl/TragfaehigkeitenMikropfahl";

export default function KnickenOfner() {
  const { t } = useTranslation("translation");

  // #region Redux Store Variables
  const bohrkronendurchmesser = useSelector(selectBohrkronendurchmesser);
  const verpresskoerperdurchmesser = useSelector(selectVerpresskoerperdurchmesser);
  const bemessungslast = Number(useSelector(selectBemessungslast));
  const tragglied = useSelector(selectTragglied);
  const undraenierteScherfestigkeit = useSelector(selectUndraenierteScherfestigkeit);
  const dickeWeicheBodenschicht = useSelector(selectDickeWeicheBodenschicht);
  const { knickenNachOfnerWimmerDetails } = useSelector(selectFrontendZustand);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const teilsicherheitsbeiwertTragglied = useSelector(selectTeilsicherheitsbeiwert);
  const koeffizientNachWenz = useSelector(selectKoeffizientNachWenz);
  const koeffizientNachGudehus = useSelector(selectKoeffizientNachGudehus);
  const teilsicherheitsbeiwertFuerGeotechnischenKenngroessen = useSelector(
    selectTeilsicherheitsbeiwertFuerGeotechnischenKenngroessen
  );
  const teilsicherheitsbeiwertZement = useSelector(selectTeilsicherheitsbeiwertZement);

  const staerkeDesZylinders = useSelector(selectStaerkeDesZylinders);
  const knickkoeffizient = useSelector(selectKnickkoeffizient);
  const biegesteifigkeit = useSelector(selectBiegesteifigkeit);
  // #endregion

  const [lambda1, setLambda] = useState(null);
  const [Ac, setAc] = useState(0);
  const [qy, setQy] = useState(0);
  const [elastischerBereichDerSeitlichenBettung, setElastischerBereichDerSeitlichenBettung] =
    useState(0);
  const [c, setC] = useState(0);
  const [m, setM] = useState(0);
  const [Lhw, setLhw] = useState(0);
  const [ersatzimperfektionsamplitude, setErsatzimperfektionsamplitude] = useState(0);
  const [Nki1, setNki] = useState(0);
  const [knicklastDesGebettetenPfahls, setKnicklastDesGebettetenPfahls] = useState(0);
  const [biegemomentdesPfahls, setBiegemomentdesPfahls] = useState(0);
  const [verformungsamplitude, setVerformungsamplitude] = useState(0);
  const [normalkrafttragfaehigkeit, setNormalkrafttragfaehigkeit] = useState(0);
  const [elastischeMomententragfaehigkeit, setElastischeMomententragfaehigkeit] = useState();
  const [berechneteKnickenWerte, setBerechneteKnickenWerte] = useState();

  function isValidNumber(inputVal) {
    if (!inputVal) return false;
    if (String(inputVal).trim() == "") return false;
    return typeof Number(inputVal) == "number" && !isNaN(inputVal) ? true : false;
  }
  useEffect(() => {
    //TODO: erweitern
    // @Alex erweitern um was ?

    if (
      dickeWeicheBodenschicht == 0 ||
      !isValidNumber(dickeWeicheBodenschicht) ||
      !isValidNumber(verpresskoerperdurchmesser)
    ) {
      setBerechneteKnickenWerte(null);
      setAc(null);
      setNormalkrafttragfaehigkeit(null);
      setElastischeMomententragfaehigkeit(null);
      setElastischeMomententragfaehigkeit(null);
      setQy(null);
      setElastischerBereichDerSeitlichenBettung(null);
      setC(null);
      setM(null);
      setLhw(null);
      setNki(null);
      setKnicklastDesGebettetenPfahls(null);
      setLambda(null);
      setErsatzimperfektionsamplitude(null);
      setBiegemomentdesPfahls(null);
      setVerformungsamplitude(null);
      return;
    }

    let KnickenOfnerResult = berechneKnickenOfner(
      biegesteifigkeit,
      knickkoeffizient,
      traggliedDaten,
      verpresskoerperdurchmesser,
      teilsicherheitsbeiwertTragglied,
      koeffizientNachWenz,
      undraenierteScherfestigkeit,
      koeffizientNachGudehus,
      dickeWeicheBodenschicht,
      bemessungslast,
      teilsicherheitsbeiwertFuerGeotechnischenKenngroessen,
      teilsicherheitsbeiwertZement
    );
    setBerechneteKnickenWerte(KnickenOfnerResult?.berechneteKnickenWerte);
    setAc(Math.floor(KnickenOfnerResult?.Aci));
    setNormalkrafttragfaehigkeit(KnickenOfnerResult?.normalkrafttragfaehigkeit);
    setElastischeMomententragfaehigkeit(KnickenOfnerResult?.elastischeMomententragfaehigkeit);
    setQy(KnickenOfnerResult?.qy_calc);
    setElastischerBereichDerSeitlichenBettung(
      KnickenOfnerResult?.elastischerBereichDerSeitlichenBettung
    );
    setC(KnickenOfnerResult?.c_calc);
    setM(KnickenOfnerResult?.m_calc);
    setLhw(KnickenOfnerResult?.lhw_calc);
    setNki(KnickenOfnerResult?.nki_calc);
    setKnicklastDesGebettetenPfahls(KnickenOfnerResult?.knicklastDesGebettetenPfahls);
    setLambda(KnickenOfnerResult?.lamba1_calc);
    setErsatzimperfektionsamplitude(KnickenOfnerResult?.ersatzimperfektionsamplitude);
    setBiegemomentdesPfahls(KnickenOfnerResult?.biegemomentdesPfahls);
    setVerformungsamplitude(KnickenOfnerResult?.verformungsamplitude);
  }, [
    biegesteifigkeit,
    knickkoeffizient,
    traggliedDaten,
    tragglied.title,
    bemessungslast,
    bohrkronendurchmesser,
    verpresskoerperdurchmesser,
    dickeWeicheBodenschicht,
    undraenierteScherfestigkeit,
    teilsicherheitsbeiwertFuerGeotechnischenKenngroessen,
    teilsicherheitsbeiwertTragglied,
    koeffizientNachWenz,
    koeffizientNachGudehus,
    teilsicherheitsbeiwertZement,
  ]);

  return (
    <SpacerContainer>
      <div className="row">
        <ContentExpansion
          expand={knickenNachOfnerWimmerDetails}
          reducer={setKnickenNachOfnerWimmerDetails}
        />
      </div>

      {knickenNachOfnerWimmerDetails == false && (
        <div className="box">
          <div className="row">
            <h1>{t("inner.buckling.crossSectionParametersMicropile")}</h1>
          </div>
        </div>
      )}

      <ParameterTragglied
        expand={knickenNachOfnerWimmerDetails}
        traggliedDaten={traggliedDaten}
        berechneteKnickenWerte={berechneteKnickenWerte}
        ym={teilsicherheitsbeiwertTragglied}
      />
      <ParameterVerpresskoerper
        expand={knickenNachOfnerWimmerDetails}
        Ac={Ac}
        fck={staerkeDesZylinders}
      />
      <TragfaehigkeitenMikropfahl
        expand={knickenNachOfnerWimmerDetails}
        elastischeMomententragfaehigkeit={elastischeMomententragfaehigkeit}
        normalkrafttragfaehigkeit={normalkrafttragfaehigkeit}
      />
      <ParameterBaugrund
        expand={knickenNachOfnerWimmerDetails}
        Nj={teilsicherheitsbeiwertFuerGeotechnischenKenngroessen}
        kc={koeffizientNachWenz}
        ky={koeffizientNachGudehus}
      />
      <Nachweis
        expand={knickenNachOfnerWimmerDetails}
        Lhw={Lhw}
        Nki1={Nki1}
        knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
        verformungsamplitude={verformungsamplitude}
        c={c}
        eo={ersatzimperfektionsamplitude}
        lambda1={lambda1}
        m={m}
        qy={qy}
        normalkrafttragfaehigkeit={normalkrafttragfaehigkeit}
        biegemomentdesPfahls={biegemomentdesPfahls}
        elastischeMomententragfaehigkeit={elastischeMomententragfaehigkeit}
        elastischerBereichDerSeitlichenBettung={elastischerBereichDerSeitlichenBettung}
      />
    </SpacerContainer>
  );
}
